import axios from 'axios';

const calculate = (salario, tipoAtividade) => {
  return axios.post(`https://us-central1-oi-contabilizei.cloudfunctions.net/calculadora/custo-cnpj`, {
    salario,
    tipoAtividade,
  });
}

export default {
  calculate
}
